import { type StatsigOptions as StatsigJsOptions } from "statsig-js";
import {
  STATSIG_EVENT_LOGGING_API_PROXY_URL,
  STATSIG_SDK_PROXY_URL,
} from "./const";

//  Roll our own stable id:
//  This is necessary because statsig client experiments set their own stable id
//  and server components let you define your own id, to get experiments that
//  combined these experiences you need one source of truth
//  For the server components where we do this we set the stable id in middleware
//  and then read it from the cookie
export const getStableId = (): string | undefined => {
  if (typeof document !== "undefined") {
    const match = document.cookie.match(
      new RegExp("(^| )pu_stable_id=([^;]+)")
    );
    return match ? match[2] : undefined;
  }
  return undefined;
};

export const clientStatsigOptions: StatsigJsOptions = {
  environment: { tier: process.env.VERCEL_ENV },
  // Reverse Proxies
  api: STATSIG_SDK_PROXY_URL,
  eventLoggingApi: STATSIG_EVENT_LOGGING_API_PROXY_URL,
  // Statsig will be enabled in ALL environments (prod, dev and preview)
  // This is done mainly so that feature flags and experiments will work in all envs alike.
  // Note: events will still not be sent - see usage of process.env.DISABLE_ANALYTICS_TRACKING.
  localMode: false,
  overrideStableID: getStableId(),
};
